import * as z from "zod/v4";

export const deleteSignupForm = {
  name: "deleteSignupForm" as const,
  input: z.object({ formId: z.string() }),
  output: z.literal("success"),
};
